import { Component } from 'react'
import { JSONFetcher } from 'shared'

// Load a project from a given apiUrl, put it into its state.
export class ProjectComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project: {
        donations_count:      0,
        comments_count:       0,
        blog_post_count:      0,
        progress_percentage:  0,
        open_amount_in_cents: 0,
        activated_at:         'not-null', // While the project is not loaded it should still use the "activated" state
      },
      loaded: false
    }
  }

  componentDidMount() {
    JSONFetcher.load({
      url:     this.props.apiUrl,
      success: (project) => { this.setState({ project: project, loaded: true }) }
    })
  }

  get status() {
    if (this.state.project.completed_at) {
      return 'completed'
    } else if (this.state.project.closed_at) {
      return 'closed'
    } else if (this.state.project.activated_at) {
      return (this.state.project.donations_prohibited) ? 'blocked' : 'activated'
    } else {
      return 'preparing'
    }
  }
}
